module.exports = __webpack_public_path__ + "static/media/montblanc-what-moves-you-makes-you.6a00ed22.mp4";